<script setup>
import { ref } from 'vue'

const gradId = ref(`hs-wallet-grad-${Math.random().toString(36).slice(2, 9)}`)
</script>

<template>
  <span class="hs-wallet-badge" aria-hidden="true">
    <svg class="hs-wallet-badge__ic" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <defs>
        <linearGradient :id="gradId" x1="4" y1="6" x2="20" y2="20" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="var(--hs-wallet-grad-a, #f5d56a)" />
          <stop offset="52%" stop-color="var(--hs-wallet-grad-b, #f0b90b)" />
          <stop offset="100%" stop-color="var(--hs-wallet-grad-c, #c99400)" />
        </linearGradient>
      </defs>
      <g transform="translate(0, -1.25)">
        <path
          :fill="`url(#${gradId})`"
          d="M5 9.25c0-1.52 1.23-2.75 2.75-2.75h8.5c1.52 0 2.75 1.23 2.75 2.75V18c0 1.52-1.23 2.75-2.75 2.75H7.75C6.23 20.75 5 19.52 5 18V9.25z"
        />
        <path
          d="M5 12.25h14"
          stroke="#fff"
          stroke-width="0.9"
          stroke-linecap="round"
          opacity="0.35"
          fill="none"
        />
        <rect x="7.25" y="10.25" width="6" height="4.25" rx="0.85" fill="#fff" opacity="0.28" />
        <circle cx="16.75" cy="14.5" r="2.15" fill="#fff" opacity="0.95" />
        <circle cx="16.75" cy="14.5" r="1" :fill="`url(#${gradId})`" />
      </g>
    </svg>
  </span>
</template>
